/**
 * 全局引导dialog
 * @module store/modules/globalGuideDialog
 * @see module:store/modules/globalGuideDialog
 * @example
 */
export default {
  namespaced: true,
  state: {
    // 所有dialog
    list: []
  },
  getters: {
    // 获取dialog
    dialogList: (state) => state.list
  },
  mutations: {
    // 添加dialog
    addDialog(state, payload) {
      const id = payload.props?.id || new Date().getTime();
      state.list.push(Object.assign({ visible: true, id, show: true }, payload));
    },
    // 关闭dialog
    closeDialog(state, payload) {
      state.list.splice(payload.index, 1);
      if (!payload.isNativeClose) payload.callBack && payload.callBack();
    },
    // 关闭所有dialog
    closeAllDialog(state) {
      state.list = [];
    }
  },
  actions: {}
};
